/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/barcode/BarcodeUseCase.yaml
import { FindAndPickScanningMode } from './FindAndPickScanningModeUseCase';
import { MultipleScanningMode } from './MultipleScanningModeUseCase';
import { SingleScanningMode } from './SingleScanningModeUseCase';
/** @internal */
export var BarcodeUseCase;
(function (BarcodeUseCase) {
    /** @internal */
    function from(source) {
        const _type = source['_type'];
        switch (_type) {
            case 'SingleScanningMode':
                return new SingleScanningMode(source);
            case 'MultipleScanningMode':
                return new MultipleScanningMode(source);
            case 'FindAndPickScanningMode':
                return new FindAndPickScanningMode(source);
            default:
                throw new Error(`Unknown child class name: ${_type}`);
        }
    }
    BarcodeUseCase.from = from;
})(BarcodeUseCase || (BarcodeUseCase = {}));
//# sourceMappingURL=BarcodeUseCase.js.map